import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      userInfo : {
          sex : 1,
          cover : '',
      },
  },
  getters:{
      getUserInfo:(state)=>{
        return state.userInfo;
      }
  },
  mutations: {
      setUserInfo : (state,userInfo) => {
          state.userInfo = userInfo;
      }
  },
  actions: {
    setUserInfo ({state,commit},userInfo){
      commit('setUserInfo',userInfo);
    },
  }
})
